"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var EntryCommander = /*#__PURE__*/function () {
  function EntryCommander() {
    (0, _classCallCheck2["default"])(this, EntryCommander);
    Entry["do"] = this["do"].bind(this);
    Entry.undo = this.undo.bind(this);
    this.editor = {};
    this.reporters = [];
    Entry.Command.editor = this.editor;
    this.doEvent = new Entry.Event(this);
    this.logEvent = new Entry.Event(this);
    this.doCommandAll = Entry.doCommandAll;
    this._storage = null;
  }
  return (0, _createClass2["default"])(EntryCommander, [{
    key: "do",
    value: function _do(commandType) {
      var _Entry = Entry,
        stateManager = _Entry.stateManager,
        EntryCommand = _Entry.Command,
        _Entry$STATIC = _Entry.STATIC,
        COMMAND_TYPES = _Entry$STATIC.COMMAND_TYPES,
        getCommandName = _Entry$STATIC.getCommandName;
      if (typeof commandType === 'string') {
        commandType = COMMAND_TYPES[commandType];
      }

      //intentionally delay reporting
      this.report(COMMAND_TYPES["do"]);
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }
      this.report(commandType, args);
      var command = EntryCommand[commandType];
      console.log('commandType', commandType, getCommandName(commandType));
      var state;
      if (stateManager && !this._checkIsSkip(commandType)) {
        state = stateManager.addCommand.apply(stateManager, (0, _toConsumableArray2["default"])([commandType, this, this["do"], command.undo].concat(command.state.apply(this, args))));
      } else if (this.checkIsChange(commandType)) {
        if (Entry.creationChangedEvent) {
          Entry.creationChangedEvent.notify();
        }
      }
      var value = command["do"].apply(this, args);
      this.doEvent.notify(commandType, args);
      var id = state ? state.id : null;
      return {
        value: value,
        isPass: function (isPass, skipCount) {
          this.isPassById(id, isPass, skipCount);
        }.bind(this)
      };
    }
  }, {
    key: "undo",
    value: function undo(commandType) {
      this.report(Entry.STATIC.COMMAND_TYPES.undo);
      var command = Entry.Command[commandType];
      var state;
      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }
      if (Entry.stateManager && command.skipUndoStack !== true) {
        state = Entry.stateManager.addCommand.apply(Entry.stateManager, [commandType, this, this["do"], command.undo].concat(command.state.apply(this, args)));
      }
      return {
        value: command["do"].apply(this, args),
        isPass: function (isPass) {
          this.isPassById(state.id, isPass);
        }.bind(this)
      };
    }
  }, {
    key: "redo",
    value: function redo(commandType) {
      this.report(Entry.STATIC.COMMAND_TYPES.redo);
      var command = Entry.Command[commandType];
      for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
        args[_key3 - 1] = arguments[_key3];
      }
      if (Entry.stateManager && command.skipUndoStack !== true) {
        Entry.stateManager.addCommand.apply(Entry.stateManager, [commandType, this, this.undo, commandType].concat(command.state.apply(null, args)));
      }
      command.undo.apply(this, args);
    }
  }, {
    key: "setCurrentEditor",
    value: function setCurrentEditor(key, object) {
      this.editor[key] = object;
    }
  }, {
    key: "isPass",
    value: function isPass() {
      var _isPass = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      if (!Entry.stateManager) {
        return;
      }
      var lastCommand = Entry.stateManager.getLastCommand();
      if (lastCommand) {
        lastCommand.isPass = _isPass;
      }
    }
  }, {
    key: "isPassById",
    value: function isPassById(id) {
      var isPass = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var skipCount = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      if (!id || !Entry.stateManager) {
        return;
      }
      var lastCommand = Entry.stateManager.getLastCommandById(id);
      if (lastCommand) {
        lastCommand.isPass = isPass;
        if (skipCount) {
          lastCommand.skipCount = !!skipCount;
        }
      }
    }
  }, {
    key: "addReporter",
    value: function addReporter(reporter) {
      reporter.logEventListener = this.logEvent.attach(reporter, reporter.add);
    }
  }, {
    key: "removeReporter",
    value: function removeReporter(reporter) {
      if (reporter.logEventListener) {
        this.logEvent.detatch(reporter.logEventListener);
      }
      delete reporter.logEventListener;
    }
  }, {
    key: "report",
    value: function report(commandType, argumentsArray) {
      var data;
      if (commandType && Entry.Command[commandType] && Entry.Command[commandType].log) {
        data = Entry.Command[commandType].log.apply(this, argumentsArray);
      } else {
        data = argumentsArray;
      }
      data.unshift(commandType);
      this.logEvent.notify(data);
    }
  }, {
    key: "applyOption",
    value: function applyOption() {
      this.doCommandAll = Entry.doCommandAll;
    }
  }, {
    key: "_checkIsSkip",
    value: function _checkIsSkip(commandType) {
      var skipUndoStack = Entry.Command[commandType].skipUndoStack;
      return skipUndoStack === true || !Entry.doCommandAll && _.includes(Entry.STATIC.COMMAND_TYPES_NOT_ALWAYS, commandType);
    }
  }, {
    key: "checkIsChange",
    value: function checkIsChange(commandType) {
      return _.includes(Entry.STATIC.COMMAND_TYPES_CHANGE_CHECK, commandType);
    }
  }]);
}();
Entry.Commander = EntryCommander;